import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Column } from "../../../lib_react_adminlte/componentes/Table";
import Api from "../../../utils/Api";
import Cookies from "../../../lib_react_frontend/utils/Cookies.jsx";
import ApiceComboEditPanel from "../../../lib_react_adminlte/componentes/ApiceComboEditPanel";
import BemVindo from "../../../lib_react_frontend/componentes/BemVindo";

import constants from "../../../utils/constants";

// função principal
function Inicio({ usuario, dispatch, empresa }) {
  // declaração da referencia que será utilizada logo abaixo

  const [cod_empresa, setCod_empresa] = useState("");

  let motivoComboEdit;

  // função que executa sempre que entramos na tela, ou se colocarmos entre [] uma variável, ele vai executar o useEffect sempre que existir uma alteração nessa variável.
  useEffect(() => {
    motivoComboEdit.modal.show();
    
  }, []);

  async function buscarCor(id_empresa) {
    const ret = await Api.buscar("cor_empresa_usuario", "", {
      empresa: id_empresa,
      usuario: usuario,
    });
    if (!ret.dados[0]) {
      return "#3c8dbc";
    }
    return ret.dados[0].cor_principal;
  }

  async function buscarImagens(id_empresa) {
    const ret = await Api.buscar("imagens_empresa", "", { id_pk: id_empresa });
    if (!ret.dados[0]) {
      return "";
    }
    return ret.dados[0];
  }

  return (
    <div className="h-100">
      <ApiceComboEditPanel
        tableMaxWidth="200px"
        tabela="tab_empresa_usuario"
        chave="id_pk"
        desc="nome_fantasia"
        ref={(e) => (motivoComboEdit = e)}
        where={
          usuario.tipo_usuario === constants.tipo_usuario_admin
            ? "admin"
            : ` b.cod_usuario = '${usuario.id_pk}' and a.dt_hr_excluido is null  and b.dt_hr_excluido is null`
        }
        escondeInput
        escondeLupa
        escondeCancelar
        escondeDescricao
        tituloRegistro="Selecione para qual empresa deseja ter acesso:"
        colunas={[
          <Column
            style={{ width: "10%" }}
            key={1}
            field="id_pk"
            className="coluna-cod"
            header="Código"
          />,
          <Column
            style={{ width: "45%" }}
            key={2}
            field="nome_fantasia"
            header="Nome Fantasia"
          />,
          <Column
            style={{ width: "45%" }}
            key={3}
            field="razao_social"
            header="Razão Social"
          />,
        ]}
        value={cod_empresa}
        pagination
        onChange={async (e) => {
          setCod_empresa(e.target.value);
          const empresa_cod = e.target.value;
          let cor_principal = await buscarCor(e.target.value);
          const imagens = await buscarImagens(e.target.value);

          if (imagens.img_capa) {
            cor_principal = "none";
          }
          dispatch({
            type: "set_empresa",
            empresa: {
              ...empresa,
              cor_principal: cor_principal,
              cod_empresa_usuario: empresa_cod,
              imagens: imagens,
            },
          });          
        }}
        api={Api}
        modalStyle={{
          width: "75%",
        }}
      />
      <BemVindo />
    </div>
  );
}

export default connect(
  (state) => ({ usuario: state.usuario, empresa: state.empresa }),
  (dispatch) => ({
    dispatch,
  })
)(Inicio);



// WEBPACK FOOTER //
// ./src/telas/Cadastros/Inicio/index.jsx